import { render, staticRenderFns } from "./AxPowerbar.vue?vue&type=template&id=7cef8f62&"
import script from "./AxPowerbar.vue?vue&type=script&lang=ts&"
export * from "./AxPowerbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cef8f62')) {
      api.createRecord('7cef8f62', component.options)
    } else {
      api.reload('7cef8f62', component.options)
    }
    module.hot.accept("./AxPowerbar.vue?vue&type=template&id=7cef8f62&", function () {
      api.rerender('7cef8f62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/powerbar/AxPowerbar.vue"
export default component.exports